/**
 * Cicha Pewność - jeden blok dowodów łączy liczby, wypowiedzi klientów i materiał redakcyjny, aby nie rozpraszać zaufania pomiędzy sekcjami.
 */
import { GoogleReviews } from "@/components/site/GoogleReviews";
import { VideoFeature } from "@/components/site/VideoFeature";
import { StatsCounters } from "@/components/site/StatsCounters";
import { siteFacts } from "@/lib/site-data";

export function EvidenceSection() {
  return (
    <section
      id="dowody"
      className="evidence-section section-pad"
      aria-labelledby="evidence-title"
    >
      <div className="shell-wide">
        <div className="asymmetric-heading">
          <div>
            <span className="section-kicker">dowody, nie deklaracje</span>
            <h2 id="evidence-title">
              Nie musisz wierzyć reklamie. Sprawdź liczby, opinie i dwa wywiady
              z ekspertem.
            </h2>
          </div>
          <p>
            Każda liczba ma podany okres. Opinie pochodzą z wizytówek Google, a
            oba wywiady prowadzą do źródła.
          </p>
        </div>
        <StatsCounters />
        <p className="stats-data-note">Dane na {siteFacts.dataAsOf}</p>
        <GoogleReviews embedded />
        <VideoFeature embedded />
      </div>
    </section>
  );
}
